import { statusStyle, displayStatus, displayStatusStyle } from "@/lib/status";

export function StatusBadge({ status, small, worker }) {
  // If worker is provided, derive a display label that includes assignment state.
  const label = worker !== undefined ? displayStatus(status, worker) : status;
  const s = worker !== undefined ? displayStatusStyle(status, worker) : statusStyle(status);
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-sm font-bold uppercase tracking-wider"
      style={{
        backgroundColor: s.bg,
        color: s.text,
        border: `1px solid ${s.border}`,
        fontSize: small ? "9px" : "10px",
        padding: small ? "1px 5px" : "2px 7px",
      }}
      data-testid={`status-badge-${label}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.dot }} />
      {label}
    </span>
  );
}

export function Pill({ label, color }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-sm text-[10px] font-bold uppercase tracking-wider px-2 py-0.5"
      style={{ color, border: `1px solid ${color}44`, backgroundColor: `${color}14` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />
      {label}
    </span>
  );
}
